import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { HttpService } from '@core/shared';

import {
  GET_OFFLINE_ORDER_HISTORY_DETAILS,
  GET_ORDER_HISTORY_DETAILS,
  UrlBuilder
} from '@core/core-api-variables';
import { ParamsBuilderService } from '@core/shared/services/params-builder.service';

@Injectable()
export class OfflineOrderManagementService {

  constructor(public http: HttpService, public paramsBuilderService: ParamsBuilderService) { }

  getOfflineOrderHistoryDetails(queryString): Observable<any> {
    let url = UrlBuilder(GET_OFFLINE_ORDER_HISTORY_DETAILS, queryString);
    return this.http.get(url).pipe(map((response: any) => {
      return response;
    }));
  }
}
